"use client";

import { type PropsWithChildren, useEffect, useRef } from "react";

import { useWindowSize } from "@/util";

export const SmoothScroll = ({ children }: PropsWithChildren) => {
  const windowSize = useWindowSize();
  const scrollingContainerRef = useRef(null);

  const data = {
    ease: 0.15,
    current: 0,
    previous: 0,
    rounded: 0,
  };

  useEffect(() => setBodyHeight(), [windowSize.height]);

  const setBodyHeight = () => {
    document.body.style.height = `${
      // @ts-ignore
      scrollingContainerRef.current.getBoundingClientRect().height
    }px`;
  };

  useEffect(() => {
    requestAnimationFrame(() => smoothScrollingHandler());
  }, []);

  const smoothScrollingHandler = () => {
    data.current = window.scrollY;
    data.previous += (data.current - data.previous) * data.ease;
    data.rounded = Math.round(data.previous * 100) / 100;

    // @ts-ignore
    scrollingContainerRef.current.style.transform = `translateY(-${data.previous}px)`;

    requestAnimationFrame(() => smoothScrollingHandler());
  };

  return (
    <div className="scroll-container">
      <div ref={scrollingContainerRef}>{children}</div>
    </div>
  );
};
